import { Button } from '@mui/material';
import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { FaFilePdf } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import { isCompany } from '../../Config/isCompany';
import NotFoundPage from '../../Pages/NotFoundPage';

const AppliedUserDetails = () => {
  const [user, setUser] = useState({});
  const [userInfo, setUserInfo] = useState({});
  const { id } = useParams(); // ID parametresi alınır
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(
          `https://kariyer.biyomed.net/api/posts/applied-users-details/${id}`,
          { withCredentials: true }
        );
        const res = await axios.post(
          `https://kariyer.biyomed.net/api/posts/applied-users-info/`,
          { user_id: response.data.user.user_id },
          { withCredentials: true }
        );
        setUser(response.data.user || []);
        setUserInfo(res.data.user || []);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    fetchUsers();
  }, [id]);

  const handleDownload = (pdfData, fileName) => {
    if (pdfData && pdfData.startsWith('data:application/pdf;base64,')) {
      const base64Data = pdfData.split('base64,')[1];  // Base64 verisini ayıklama

      const pdfBlob = new Blob([new Uint8Array(atob(base64Data).split("").map(c => c.charCodeAt(0)))], { type: 'application/pdf' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(pdfBlob);

      link.href = url;
      link.download = fileName; // Kullanıcının indireceği dosya adı
      link.click();

      // URL'yi serbest bırak
      URL.revokeObjectURL(url);
    } else {
      console.error("Geçersiz Base64 verisi:", pdfData);
      alert("Geçersiz PDF verisi.");
    }
  };
  return (
    <>{isCompany ?     <div className="jp_cp_profile_main_wrapper">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <div className="jp_cp_left_side_wrapper">
              <div className="jp_cp_left_pro_wallpaper">
              <img src={user.profile_image ? user.profile_image : " https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"} alt="profile_img" />
                <p>{userInfo.user_type}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
            <div className="jp_cp_right_side_wrapper">
              <div className="jp_cp_right_side_inner_wrapper">
                <h2>Başvuran Detay</h2>
                <table>
                  <tbody>
                    <tr>
                      <td className="td-w25">Ad</td>
                      <td className="td-w10">:</td>
                      <td className="td-w65">{userInfo?.first_name}</td>
                    </tr>
                    <tr>
                      <td className="td-w25">Soyad</td>
                      <td className="td-w10">:</td>
                      <td className="td-w65">{userInfo?.last_name}</td>
                    </tr>
                    <tr>
                      <td className="td-w25">E-posta</td>
                      <td className="td-w10">:</td>
                      <td className="td-w65">{userInfo?.email}</td>
                    </tr>
                    <tr>
                      <td className="td-w25">Telefon</td>
                      <td className="td-w10">:</td>
                      <td className="td-w65">{userInfo?.phone}</td>
                    </tr>
                    <tr>
                      <td className="td-w25">Portföy Bağlantısı</td>
                      <td className="td-w10">:</td>
                      <td className="td-w65">{user?.profile_link1} <a style={{color:"blue"}} href={user?.profile_link1}>Linke Git</a></td>
                    </tr>
                    {user?.profile_link2 ?                    <tr>
                      <td className="td-w25">Ekstra Portföy Bağlantısı</td>
                      <td className="td-w10">:</td>
                      <td className="td-w65">{user?.profile_link2} <a style={{color:"blue"}} href={user?.profile_link2}>Linke Git</a></td>
                    </tr> : ''}
                    <tr>
                      <td className="td-w25">Diller</td>
                      <td className="td-w10">:</td>
                      <td className="td-w65">{user?.languages?.replace(/\./g, ' ').replace(/,/g, ', ')}</td>
                    </tr>
                    <tr>
                      <td className="td-w25">İş Durumu</td>
                      <td className="td-w10">:</td>
                      <td className="td-w65">{user?.job_status}</td>
                    </tr>
                    <tr>
                      <td className="td-w25">Ehliyet</td>
                      <td className="td-w10">:</td>
                      <td className="td-w65">{user?.driver_license_status}</td>
                    </tr>
                    <tr>
                      <td className="td-w25">Pozisyon Etiketi</td>
                      <td className="td-w10">:</td>
                      <td className="td-w65">{user?.position_tags}</td>
                    </tr>
                    <tr>
                      <td className="td-w25">İlgilendiği Kategori</td>
                      <td className="td-w10">:</td>
                      <td className="td-w65">{user?.category_of_interest}</td>
                    </tr>
                    <tr>
                      <td className="td-w25">Şehir</td>
                      <td className="td-w10">:</td>
                      <td className="td-w65">{user?.residence_city}</td>
                    </tr>
                    <tr>
                      <td className="td-w25">Askerlik Durumu</td>
                      <td className="td-w10">:</td>
                      <td className="td-w65">{user?.military_status}</td>
                    </tr>
                    <tr>
                      <td className="td-w25">{userInfo.user_type ==="Mezun"?'Mezuniyet Yılı': 'Tahmini Mezuniyet Yılı'}</td>
                      <td className="td-w10">:</td>
                      <td className="td-w65">{userInfo?.graduation_year}</td>
                    </tr>
                    <tr>
                      <td className="td-w25">Türkçe Özgeçmiş</td>
                      <td className="td-w10">:</td>
                      <td>
                        {user.cv_turkish ? 
                          <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => handleDownload(user.cv_turkish, `${user.first_name}_cv_turkish.pdf`)}
                            startIcon={<FaFilePdf />}
                          >
                            Belgeyi indir
                          </Button>: <p>Mevcut Değil</p>
                         }
                      </td>
                    </tr>
                    <tr>
                      <td className="td-w25">İngilizce Özgeçmiş</td>
                      <td className="td-w10">:</td>
                      <td>
                        {user.cv_english ?
                          <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => handleDownload(user.cv_english, `${user.first_name}_cv_english.pdf`)}
                            startIcon={<FaFilePdf />}
                          >
                            Belgeyi indir
                          </Button>: <p>Mevcut Değil</p>
                        }
                      </td>
                    </tr>
                  </tbody>

                </table>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                <div className="jp_cp_accor_heading_wrapper">
                  <h2>Eğİtİm</h2>
                  <p> Yuksek Lisans : {user.masters} </p>
                  <p> Lisans  : {user.undergraduate}</p>
                  <p> Lise  : {user.highschool}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> : <NotFoundPage/> }</>

  );
};

export default AppliedUserDetails;
